import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, MessageSquare, Users } from 'lucide-react';
import api from '../../services/api';
import { useForumStats } from '../../hooks/useApi';
import ForumPreviewCard from './ForumPreviewCard';
import { ForumThreadRow } from './forumLabels';

type Props = {
  isMobile: boolean;
};

const CommunitySection: React.FC<Props> = ({ isMobile }) => {
  const { stats, loading: statsLoading } = useForumStats();
  const [threads, setThreads] = useState<ForumThreadRow[]>([]);
  const [threadsLoading, setThreadsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.getForumThreads({ limit: 3, page: 1 });
        if (!cancelled && res.success) {
          setThreads(res.data.threads || []);
        }
      } catch {
        if (!cancelled) setThreads([]);
      } finally {
        if (!cancelled) setThreadsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section id="community" className="community-section">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="community-section__header"
      >
        <div className="section-badge">
          <MessageSquare size={16} />
          Topluluk forumu
        </div>
        <h2>
          <span className="gradient-text-white">Soru sor, not iste, görsel paylaş</span>
        </h2>
        <p>
          Canlı tartışmalar, kategori filtreleri ve güvenli görsel paylaşımı. Son konulara göz atın veya foruma katılın.
        </p>
      </motion.div>

      <div className="community-section__stats">
        <div className="community-stat glow-card">
          <MessageSquare size={20} />
          <strong>{statsLoading ? '…' : stats?.totalThreads ?? 0}</strong>
          <span>konu</span>
        </div>
        <div className="community-stat glow-card">
          <Users size={20} />
          <strong>{statsLoading ? '…' : stats?.totalReplies ?? 0}</strong>
          <span>yanıt</span>
        </div>
      </div>

      {!threadsLoading && threads.length > 0 && (
        <div className="community-section__previews">
          {threads.map((t, i) => (
            <ForumPreviewCard key={t._id} thread={t} index={i} />
          ))}
        </div>
      )}

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="community-section__cta glow-card"
        style={{ padding: isMobile ? '28px 20px' : '36px 32px' }}
      >
        <p>Foruma geçerek yeni konu açabilir, mevcut tartışmalara yanıt verebilirsiniz.</p>
        <div className="community-section__cta-actions">
          <motion.div whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }}>
            <Link to="/forum" className="community-section__btn btn-shimmer">
              Foruma git
              <ArrowRight size={18} />
            </Link>
          </motion.div>
          <Link to="/forum" className="community-section__link">
            Tüm konulara git →
          </Link>
        </div>
      </motion.div>
    </section>
  );
};

export default CommunitySection;
